import { forwardRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { appContext } from "../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faCheck } from "@fortawesome/free-solid-svg-icons";

export const JoinSegmentCloudComponent = forwardRef<HTMLDivElement, any>((props, ref) => {
    const { darkMode } = useContext(appContext);
    const navigate = useNavigate();

    return (
        <section ref={ref} className="py-16 relative">
            <div className="container mx-auto px-4">
                <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-slate-900 to-blue-900 text-white">
                    {/* Subtle background accent */}
                    <div className="absolute top-0 right-0 w-48 h-48 bg-blue-500/10 rounded-full blur-3xl"></div>

                    <div className="relative p-8 md:p-12">
                        <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
                            {/* Left Content - Minimal */}
                            <div className="flex-1 text-center lg:text-left">
                                <h2 className="text-3xl md:text-4xl font-bold mb-4">
                                    Start Mining
                                    <br />
                                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
                                        In Minutes
                                    </span>
                                </h2>
                                
                                <p className="text-slate-300 mb-6 max-w-md text-lg">
                                    Join investors worldwide. Start earning today.
                                </p>

                                {/* Simple benefits */}
                                <div className="flex flex-wrap gap-4 mb-6">
                                    <div className="flex items-center gap-2 text-sm text-slate-300">
                                        <div className="w-2 h-2 rounded-full bg-green-500"></div>
                                        <span>Lowest Fees</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-sm text-slate-300">
                                        <div className="w-2 h-2 rounded-full bg-green-500"></div>
                                        <span>24/7 Support</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-sm text-slate-300">
                                        <div className="w-2 h-2 rounded-full bg-green-500"></div>
                                        <span>Instant Setup</span>
                                    </div>
                                </div>
                            </div>

                            {/* Right CTA - Clean */}
                            <div className="w-full lg:w-auto">
                                <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 md:p-8 max-w-md">
                                    <div className="space-y-4 mb-6">
                                        <div className="flex items-center gap-3">
                                            <FontAwesomeIcon icon={faCheck} className="text-blue-400 text-sm" />
                                            <span className="text-slate-300 text-sm">No setup fees</span>
                                        </div>
                                        <div className="flex items-center gap-3">
                                            <FontAwesomeIcon icon={faCheck} className="text-blue-400 text-sm" />
                                            <span className="text-slate-300 text-sm">No minimum deposit</span>
                                        </div>
                                        <div className="flex items-center gap-3">
                                            <FontAwesomeIcon icon={faCheck} className="text-blue-400 text-sm" />
                                            <span className="text-slate-300 text-sm">Expert support</span>
                                        </div>
                                    </div>

                                    <div className="space-y-3">
                                        <button
                                            onClick={() => navigate('/signup')}
                                            className="w-full py-3 bg-gradient-to-r from-blue-500 to-cyan-500 text-white font-bold rounded-lg hover:shadow-lg transition-all flex items-center justify-center gap-2 group"
                                        >
                                            Start Now
                                            <FontAwesomeIcon icon={faArrowRight} className="text-sm group-hover:translate-x-1 transition-transform" />
                                        </button>
                                        
                                        <p className="text-center text-xs text-slate-400">
                                            Free trial • Cancel anytime
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});